/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AcrylicSurfaceComponent } from './acrylic-surface.component';

@NgModule({
  declarations: [AcrylicSurfaceComponent],
  imports: [CommonModule],
  exports: [AcrylicSurfaceComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AcrylicSurfaceModule {}
